module.exports = __webpack_public_path__ + "img/01.b17d6879.jpg";